export const TaskStatus = [{
    id: 0,
    name: ''
}, {
    id: 1,
    name: 'Új'
}, {
    id: 2,
    name: 'Fejlesztés alatt'
}, {
    id: 3,
    name: 'Tesztelhető'
}, {
    id: 4,
    name: 'Kész'
}, {
    id: 5,
    name: 'Elfogadva'
}];
